import { FETCH_RATING } from '../actions/RatingAction';

export default function (state = {
  status: 'Error'
}, action) {
  switch (action.type) {
    case FETCH_RATING:
        return {
          ...action.payload
        }  
    default:
      return {
        ...state
      }
  }
}


// WEBPACK FOOTER //
// ./src/reducers/RatingReducer.js